import React, { useState, useEffect } from 'react';
 
import CategoryBar from '../components/CategoryBar';
import CartDrawer from '../components/CartDrawer';
import FloatingBottomBar from '../components/FloatingBottomBar';
import SizeModal from '../components/SIzeModal';
import { useParams } from 'react-router-dom';
import VisitorInfoModal from '../components/VisitorInfoModal';
import VisitorHeader from '../components/VisitorHeader';
import { apiService } from '../services/apiServices';
import ProductCard from '../components/ProductCard';

export default function Menu() {
  const { shopCode, design } = useParams();

  const [business, setBusiness] = useState(null);
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [activeCategory, setActiveCategory] = useState('All');
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [selectedSizeModal, setSelectedSizeModal] = useState(null);
  const [orderInfo, setOrderInfo] = useState({location: '', notes: '' });
  const [selectedPayment, setSelectedPayment] = useState('');


  const [visitor, setVisitor] = useState(null);
const [showVisitorModal, setShowVisitorModal] = useState(false);


useEffect(() => {
  const savedVisitor = localStorage.getItem('visitorInfo');

  if (savedVisitor) {
    try {
      const parsedVisitor = JSON.parse(savedVisitor);
      setVisitor(parsedVisitor);

    
    } catch {
      localStorage.removeItem('visitorInfo');
      setShowVisitorModal(true);
    }
  } else {
    setShowVisitorModal(true);
  }
}, [shopCode]);

const handleVisitorSave = async (info) => {
  // Update local state and persistence immediately
  setVisitor(info);
  localStorage.setItem('visitorInfo', JSON.stringify(info));
  setShowVisitorModal(false);
  const  payload = {
    ...info,
    business_id : business.id
  }
  // Post visitor information to the backend API
  try {
   const visistorRes =  await apiService.post(`/create-apikey/register-order_app_visitors`, payload);
  console.log('visistorRes:',visistorRes, 'payload:',payload)
  } catch (error) {
    console.error('Failed to save visitor info to server:', error.message);
  }
};

const editVisitor = () => {
  setShowVisitorModal(true);
};

  // Fetch shop data dynamically when shopCode changes
  useEffect(() => {
    async function loadShopData() {
      try {
        setLoading(true);
        setError(null);

        // Option 1: Dynamic import if JSON files are local in project
        // E.g., assets stored in public or src/data/shops/[shopCode]/
        // const businessModule = await import(`../data/shops/${shopCode}/business.json`);
        // const menuModule = await import(`../data/shops/${shopCode}/menu.json`);

        // Fetch business and menu data concurrently using the service
      
        // Option 2: Fetching from public folder or remote API endpoint:
        const data = await  apiService.get(`/getlink-apikey/shop-data-json/${shopCode}`);
        const parsedDate = JSON.parse(data.report[0].full_shop_data);
      //  console.log('data:',parsedDate)
        // if (!resBiz.ok || !resMenu.ok) throw new Error('Shop not found');
        const businessModule = parsedDate.business;
        const menuModule = parsedDate.menu;
        

        setBusiness(businessModule.default || businessModule);
        setMenuData(menuModule.default || menuModule);

        // // Set default payment method once business data loads
        // const defaultPayment = (businessModule.default || businessModule).paymentMethods?.[0]?.id || '';
        // setSelectedPayment(defaultPayment);
      } catch (err) {
        console.error('Failed to load menu for shop:', shopCode, err);
        setError('Shop menu not found.');
      } finally {
        setLoading(false);
      }
    }

    if (shopCode) {
      loadShopData();
    }
  }, [shopCode]);

  // console.log('bus:',business)
  // Extract unique categories dynamically from the shop's menu data
  const categories = ['All', ...new Set(menuData.map(item => item.category).filter(Boolean))];

  const filteredItems = activeCategory === 'All'
    ? menuData
    : menuData.filter(item => item.category === activeCategory);

  const handleAddItem = (item) => {
    if (item.hasSizes) {
      setSelectedSizeModal(item);
    } else {
      addToCart(item, null, item.price);
    }
  };

  const addToCart = (item, sizeObj, price) => {
    const cartId = sizeObj ? `${item.id}-${sizeObj.name}` : item.id;
    const name = sizeObj ? `${item.name} (${sizeObj.name})` : item.name;

    setCart(prev => {
      const existing = prev.find(i => i.cartId === cartId);
      if (existing) {
        return prev.map(i => i.cartId === cartId ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prev, { cartId, name, price, qty: 1 }];
    });
    setSelectedSizeModal(null);
  };

  const updateQty = (cartId, delta) => {
    setCart(prev => prev.map(item => {
      if (item.cartId === cartId) {
        const newQty = item.qty + delta;
        return newQty > 0 ? { ...item, qty: newQty } : null;
      }
      return item;
    }).filter(Boolean));
  };

  const totalItemsCount = cart.reduce((sum, i) => sum + i.qty, 0);
  const totalPrice = cart.reduce((sum, i) => sum + i.price * i.qty, 0);

  const sendWhatsAppOrder = async () => {
    if (!business) return;
    if (cart.length === 0) return alert('Please add items to your cart');
    if (!orderInfo.notes || !orderInfo.location) return alert('Please enter your Name and Location');

     

    //Post api order
const paymentMethodObj = business.paymentMethods?.find(p => p.id === selectedPayment);
  const paymentName = paymentMethodObj ? paymentMethodObj.name : selectedPayment;

  // Order JSON payload without customer object
  const orderPayload = {
    shopCode,
    businessId: business.id,
    visitorPhone: visitor?.phone || 0,
    paymentMethodId: selectedPayment || null,
    location: orderInfo.location,
    notes: orderInfo.notes || '',
    deliveryFee: 0.00,
    totalAmount: totalPrice,
    items: cart.map(item => ({
      cartId: item.cartId,
      name: item.name,
      price: item.price,
      quantity: item.qty,
      subtotal: item.price * item.qty
    }))
  };

  // 1. Post order to backend API
  try {
   const orderRes = await apiService.post(`/create-json-apikey/save-order-json`, orderPayload);
   console.log('order:', orderRes)
  } catch (error) {
    console.error('Failed to record order in backend:', error);
  }

    //end api


    let text = `*New Order - ${business?.name}*\n`;
    text += `📍 *Location:* ${orderInfo.location}\n`;
    text += `👤 *Customer:* ${visitor?.name}\n`;
      text += `👤 *Customer:* ${visitor.phone}\n`;
    
    text += `💳 *Payment Method:* ${paymentName}\n`;
    if (orderInfo.notes) text += `📝 *Notes:* ${orderInfo.notes}\n`;
    text += `--------------------------------\n`;

    cart.forEach(item => {
      text += `${item.qty}x ${item.name} - ${business.currency} ${item.price * item.qty}\n`;
    });

    text += `--------------------------------\n`;
    text += `*Total Amount:* ${business.currency} ${totalPrice}`;

    window.open(`https://wa.me/${business.whatsappNumber}?text=${encodeURIComponent(text)}`, '_blank');
  };

  const openWhatsAppChat = () => {
    if (!business) return;
    const text = `Hello ${business.name}, I have an inquiry about your menu.`;
    window.open(`https://wa.me/${business.whatsappNumber}?text=${encodeURIComponent(text)}`, '_blank');
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '2rem' }}>Loading menu...</div>;
  }

  if (error || !business) {
    return <div style={{ textAlign: 'center', padding: '2rem' }}>{error || 'Shop not found'}</div>;
  }

  return (
    <div style={containerStyle}>

  
    <VisitorHeader
      business={business}
      visitor={visitor}
      onEdit={editVisitor}
    />

 

    {/* rest of your menu */}
      <CategoryBar
        categories={categories}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />

      <div style={{ paddingBottom: '120px' }}>
        {filteredItems.map(item => (
          <ProductCard
            key={item.id}
            item={item}
            currency={business.currency}
            onAddItem={handleAddItem}
            design={design}
          />
        ))}
      </div>

      <FloatingBottomBar
        cart={cart}
        currency={business.currency}
        totalPrice={totalPrice}
        totalItemsCount={totalItemsCount}
        onOpenCart={() => setShowCart(true)}
        onOpenWhatsAppChat={openWhatsAppChat}
      />

      <SizeModal
        item={selectedSizeModal}
        currency={business.currency}
        onSelectSize={addToCart}
        onClose={() => setSelectedSizeModal(null)}
      />

      {showCart && (
        <CartDrawer
          cart={cart}
          currency={business.currency}
          totalPrice={totalPrice}
          paymentMethods={business.paymentMethods || []}
          orderInfo={orderInfo}
          setOrderInfo={setOrderInfo}
          selectedPayment={selectedPayment}
          setSelectedPayment={setSelectedPayment}
          updateQty={updateQty}
          onClose={() => setShowCart(false)}
          onSendWhatsApp={sendWhatsAppOrder}
        />
      )}

      {showVisitorModal && (
  <VisitorInfoModal
    onSave={handleVisitorSave}
  />
)}
    </div>

    
  );
}

const containerStyle = { maxWidth: '480px', margin: '0 auto', background: '#F9FAFB', minHeight: '100vh', padding: '0.75rem', position: 'relative' };